import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { StatusAccount } from '../login/type';
import { OtpToken, Profile } from '../profile/data';

const defaultApi = '/api/auth';
type Item = Profile;

type RegisterParams = {
  phoneNumber: string;
  fullname: string;
  email: string;
  password: string;
  passwordConfirmation: string;
  gender: number;
};

type PreLoginResponse = {
    phoneNumber: string
    id: number
    fullname: string
    email: string
    gender: any
    status: StatusAccount
    isFulfilledProfile: boolean
    isVerifiedEmail: boolean
    isFirstLogin: boolean
  }


const register = (body: RegisterParams) => {
  return api.post<ApiResponse<Profile>>(defaultApi + '/register', body);
};

export type LoginParams = {
  account: string;
  password: string;
  firebaseToken: string;
};
const login = async (body: LoginParams) => {
  return api.post<ApiResponse<Item>>(defaultApi + '/login', body);
};

const logout = async () => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/logout',
    {},
    {
      headers: authHeader(),
    },
  );
};

const logoutAll = async () => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/logout/all',
    {},
    {
      headers: authHeader(),
    },
  );
};

const verifyEmail = (body: { token: string }) => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/verification/verify/email',
    body,
  );
};

const resendVerificationEmail = () => {
  return api.post<ApiResponse<object>>(
    defaultApi + '/verification/notice/email',
    {},
    {
      headers: authHeader(),
    },
  );
};

type VerifyPhoneParams = {
  phoneNumber: number;
  code: string;
  otpToken: string;
};
const verifyPhone = (body: VerifyPhoneParams) => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/verification/verify/phone',
    body,
  );
};

const resendVerificationOTP = () => {
  return api.post<ApiResponse<OtpToken>>(
    defaultApi + '/verification/notice/phone',
    {},
    {
      headers: authHeader(),
    },
  );
};

type ChangePasswordParams = {
  password: string;
  newPassword: string;
  passwordConfirmation: string;
};
const changePassword = async (body: ChangePasswordParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultApi + '/password',
    body,
    {
      headers: authHeader(),
    },
  );
};

const requestPasswordRecovery = async (body: { email: string }) => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/password/email',
    body,
  );
};

type ResetPasswordParams = {
  token: string;
  email: string;
  password: string;
  passwordConfirmation: string;
};
const resetPassword = async (body: ResetPasswordParams) => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/password/reset',
    body,
    {
      headers: authHeader(),
    },
  );
};

const checkEmailToken = async (body: { email: string; token: string }) => {
  return api.post<ApiResponse<{ success: boolean }>>(
    defaultApi + '/password/check-token',
    body,
    {
      headers: authHeader(),
    },
  );
};

const preLogin = async (body: { email: string }) => {
  return api.post<ApiResponse<PreLoginResponse>>(
    defaultApi + '/pre-login',
    body,
    {
      headers: authHeader(),
    },
  );
};

type PasswordFirstLoginParams = {
  newPassword: string;
  passwordConfirmation: string;
}
const updatePassword = async (body: PasswordFirstLoginParams, token: string) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultApi + '/update-password',
    body,
    {
      headers: {
        Authorization: 'Bearer ' + token
      },
    },
  );
};


const checkPassCode = async (body: {email: string, code: string }) => {
  return api.post<ApiResponse<{token: string}>>(
    defaultApi + '/password/check-pass-code',
    body,
    {
      headers: authHeader(),
    },
  );
};

export const authService = {
  register,
  login,
  logout,
  logoutAll,
  verifyEmail,
  resendVerificationEmail,
  verifyPhone,
  resendVerificationOTP,
  changePassword,
  requestPasswordRecovery,
  resetPassword,
  checkEmailToken,
  preLogin,
  updatePassword,
  checkPassCode
};
